import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const getSize = (size) => {
  switch (size) {
    case 'small':
      return '12px'
    case 'regular':
      return '18px'
    case 'large':
      return '24px'
    case 'x-large':
      return '37px'
    case 'xx-large':
      return '48px'
    default:
      return size
  }
}

const SvgWrapper = styled.div`
  filter: ${props => props.glow ? `drop-shadow(0 0 5px ${props.color})` : (props.filter || 'none')};
  position: ${props => props.position || 'relative'};
  height: ${props => getSize(props.size)};
  width: ${props => getSize(props.size)};
  pointer-events: none;
  > svg {
    pointer-events: ${props => props.clickThrough ? 'none' : ''};
    opacity: ${props => props.active === false ? 0 : 1};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) ${props => props.flipped ? 'scale(-1)' : ''};
    height: ${props => getSize(props.size)};
    width: ${props => getSize(props.size)};
    fill: ${props => props.color};
  }
`

const Icon = (props) => {
  let [svg, setSvg] = useState(null)

  useEffect(() => {
    importSvg(props.name)
  }, [])

  const importSvg = async (name) => {
    try {
      let loadedSvg = await require(`../../../public/assets/icons/${props.name}.svg`)
      setSvg(loadedSvg.default)
    } catch (err) {
      //
    }
  }

  return <SvgWrapper {...props}>{svg || null}</SvgWrapper>
}

Icon.displayName = 'Icon'

Icon.defaultProps = {
  size: 'regular'
}

Icon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.any,
  size: PropTypes.string,
  filter: PropTypes.string,
  glow: PropTypes.bool,
  active: PropTypes.bool,
  clickThrough: PropTypes.bool,
  position: PropTypes.string,
  className: PropTypes.string,
  flipped: PropTypes.bool
}

export default Icon
